<template>
  <div class="">
    <el-form :inline="true">
         <el-form-item label="类型">
        <el-select v-model="type" placeholder="类型" clearable>
          <el-option v-for="(item,i) in typeMap" :key="i" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="教练">
          <el-input v-model="name" placeholder="教练姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList(1)">搜索</el-button>
        </el-form-item>
      </el-form>
   
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #type="{ row }">
        <div>
          {{getLabel("typeMap",row.type) }}
        </div>
      </template>
        <template #status="{ row }">
        <el-tag size="small" type="info" v-if="row.status === 0">待处理</el-tag>
        <el-tag size="small" type="success" v-if="row.status === 1"
          >通过</el-tag
        >
        <el-tag size="small" type="danger" v-if="row.status === 2">拒绝</el-tag>
      </template>
    </auto-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      DataList: [],
      Option: [
        { name: "教练", value: "name" },
        { name: "类型", value: "type", type: "custom" },
        { name: "状态", value: "status", type: "custom" },
         { name: "说明", value: "remark" },
          { name: "处理人", value: "handler_name" },
        { name: "时间", value: "create_time" },
      ],
      Total: 0,
      type: "",
      name:'',
      id: "",
      adminInfo: JSON.parse(localStorage.getItem("managerInfo")),
       typeMap: [
        {
          label: "教练申请加入",
          value: "join",
        },
         {
          label: "公会邀请",
          value: "invite_add",
        },
         {
          label: "退出公会",
          value: "exit",
        }
      ],
    };
  },

  mounted() {
    this.id = this.$route.query.id;
    this.getList(1);
  },

  methods: {
    load() {
      if (this.DataList.length == 0) {
        this.getList(1);
      }
    },
    getLabel(list, v) {
      for (let index = 0; index < this[list].length; index++) {
        if (this[list][index].value === v) {
          return this[list][index].label;
        }
      }
    },
   
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/applyUnionRecord/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          union_id: this.id,
          type:this.type || null,
          name:this.name || null
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>